export default __webpack_public_path__ + "static/media/illus02.ec5acc30.png";